import type React from 'react';
import { EditAndDeleteDropdown } from '@widgets/shared/EditAndDeleteDropdown/index.ts';
import { useGroupDelete } from '@features/clients/editor-group/group-delete';
import { useOpenEditor } from '@features/clients/editor-group/group-edit';

type Props = {
  groupId: number;
};

export const MainMenu: React.FC<Props> = ({ groupId }) => {
  const { edit } = useOpenEditor(groupId);
  const { removeGroup } = useGroupDelete(groupId);
  return (
    <EditAndDeleteDropdown
      onDelete={() => {
        removeGroup();
      }}
      onEdit={() => {
        edit();
      }}
    />
  );
};
